import { useParams } from "react-router-dom";
import { DetailPageSections } from "../shared";
import { AppDiskAttachmentsList } from "../shared/persistent-disk";

export const AppDetailDiskStoragePage = () => {
  const { id = "" } = useParams();

  return (
    <div className="mb-4">
      <DetailPageSections>
        <AppDiskAttachmentsList appId={id} />
      </DetailPageSections>
    </div>
  );
};
